import createNS from '../../../utils/helpers/svg_elements';

function ShapeGroupData() {
  this.it = [];
  this.prevViewData = [];
  this.gr = createNS('g');
}

export default ShapeGroupData;
